// @flow

import ar from './ar';
import de from './de';
import en from './en';
import id from './id';
import ja from './ja';
import ko from './ko';
import vi from './vi';

export default {
  ar,
  en,
  vi,
  ja,
  ko,
  de,
  id,
};
